<template>
  <a
    v-if="isHashLink"
    :href="to"
    class="bg-white border-solid border-gray-300 hover:border-primary-lighter focus:border-primary-lighter border rounded-md flex items-center justify-center h-9 w-9 md:h-11 md:w-11 dark:bg-gray-800 dark:border-gray-600"
    :class="{
      'bg-[#50c0ff1a] cursor-auto pointer-events-none border-[#50C0FF]': active,
      'hover:border-gray-300 cursor-auto pointer-events-none !text-gray-300 dark:!text-gray-600':
        disabled,
    }"
    @click="hashLinkClicked"
  >
    <slot />
  </a>
  <component
    :is="actualComponent"
    v-else
    class="bg-white border-solid border-gray-300 hover:border-primary-lighter focus:border-primary-lighter border rounded-md flex items-center justify-center h-9 w-9 md:h-11 md:w-11 dark:bg-gray-800 dark:border-gray-600"
    :class="{
      'bg-[#50c0ff1a] cursor-auto pointer-events-none border-[#50C0FF]': active,
      'hover:border-gray-300 cursor-auto pointer-events-none !text-gray-300 dark:!text-gray-600':
        disabled,
    }"
    :to="to"
    @click="linkClicked"
  >
    <slot />
  </component>
</template>

<script>
import { computed, useRouter } from "@nuxtjs/composition-api";

export default {
  props: {
    to: {
      type: [Object, String],
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const router = useRouter();

    // Check if the link is a hash-based URL (string containing # or ending with path without hash for page 1)
    const isHashLink = computed(() => {
      return typeof props.to === "string";
    });

    const linkClicked = (e) => {
      if (props.disabled) {
        e.stopPropagation();
        e.preventDefault();
        return;
      }
      emit("click");
    };

    /**
     * Handle click on hash-based pagination links
     * Uses Vue Router for SPA navigation so $route.hash updates reactively
     */
    const hashLinkClicked = (e) => {
      if (props.disabled) {
        e.stopPropagation();
        e.preventDefault();
        return;
      }

      e.preventDefault();
      emit("click");

      if (props.to) {
        // Use Vue Router to navigate - this updates $route reactively
        router.push(props.to);
      }
    };

    const actualComponent = props.to ? "NuxtLink" : "button";

    return {
      isHashLink,
      linkClicked,
      hashLinkClicked,
      actualComponent,
    };
  },
};
</script>
